<template>
  <div class="panier-component mt-15">
    <div class=" columns has-background-white">
      <div class="column is-narrow column-img ml-40 mr-12">
        <img v-if="panneau.urlPhoto"
            class="image tailleImage"
            :src="panneau.urlPhoto">
        <img v-else class="image tailleImage" src="@/assets/default-placeholder.png"/>
        <p class="has-text-weight-bold has-text-dark is-size-6">
          Panneau n°<span>{{panneau.code}}</span>
        </p>
        <b-modal v-model="isComponentDetailFacesLc"
               has-modal-card
               class="modal">
              <info-window-produit :panneau ="panneau"/>
        </b-modal>
        <a class="plusInfo" @click="isComponentDetailFacesLc = !isComponentDetailFacesLc">
          Plus d'informations sur l'écran
        </a>
     </div>
      <div class="column columns">
        <div class="column is-paddingless is-one-third">
          <div class="column is-12 p-5px">
              <b-field label="Tarif HT" class="mb-0" custom-class="mb-0 label-color" expanded>
                <input-currency v-model="panneau.extensionOpportunite.tarifHt"
                                isNumber="true"
                                :disabled="disabled"/>
              </b-field>
          </div>
          <div class="column is-12 p-5px">
            <div class="control">
              <label class="subtitle">Taxes municipales / TLPE</label>
              <input-currency v-model="panneau.extensionOpportunite.taxeMunicipale"
                              :disabled="disabled">
              </input-currency>
            </div>
          </div>
          <div class="column is-12 p-5px">
            <label class="subtitle">Diffusions / jour</label>
            <input class="input"
                    type="number"
                    v-model="panneau.extensionOpportunite.nbDiffusion"
                    :disabled="disabled">
          </div>
        </div>
        <div class="column is-paddingless is-one-third">
          <div class="column is-12 p-5px">
            <b-field grouped>
              <b-field label="Quantité" class="mb-0" custom-class="mb-0 label-color" expanded>
                <input class="input"
                    type="number"
                    v-model="panneau.extensionOpportunite.quantite"
                    :disabled="disabled">
              </b-field>
            <b-field>
            <div>
              <label class="subtitle">Tarification</label>
                <b-select v-model="panneau.extensionOpportunite.typeTarification"
                  expanded :disabled="disabled">
                <option :key="tarif.value" :value="tarif.value" v-for="tarif in tarifications" >
                  {{tarif.libelle}}
                </option>
                </b-select>
            </div>
            </b-field>
</b-field>
          </div>
          <div class="column is-12 p-5px">
            <div class="control">
              <label class="subtitle">Frais technique</label>
              <input-currency v-model="panneau.extensionOpportunite.fraisAdserving"
                              isNumber="true"
                              :disabled="disabled">
              </input-currency>
            </div>
          </div>
          <div class="column is-12 p-5px">
            <div class="control">
              <label class="subtitle">Spots pub</label>
              <input class="input"
                    type="number"
                    v-model="panneau.extensionOpportunite.spotsPub"
                    :disabled="disabled">
            </div>
          </div>
        </div>
        <div class="column is-paddingless is-one-third">
          <div class="column is-12 p-5px">
           <b-field label="Remise" class="mb-0" custom-class="mb-0 label-color" expanded>
                <b-field>
                  <input-currency v-model="panneau.extensionOpportunite.remise"
                                  isNumber="true"
                                  :disabled="disabled"/>
                  <b-select v-model="panneau.extensionOpportunite.typeDeRemise" placeholder="0">
                    <option :value="0">%-</option>
                    <option :value="1">€</option>
                  </b-select>
                </b-field>
            </b-field>
            </div>
          <div class="column is-12 p-5px">
            <b-field label="Commentaire" custom-class="mb-0 label-color">
              <b-input
                type="textarea"
                v-model="panneau.extensionOpportunite.commentaire"
                :disabled="disabled"/>
            </b-field>
          </div>
        </div>
      </div>

      <div class="column is-1 is-paddingless mr-20">
        <div class="is-flex flex-align-center-justify-end p-5px">
          <p class="has-text-weight-bold is-size-6 has-text-black mr-12">
            {{panneau.prixTotal}} €
          </p>
          <a @click="suppressionPanneau">
            <b-icon icon="delete-forever" type="is-danger"/>
          </a>
        </div>
      </div>
    </div>
    <div class="control has-background-white">
      <label class="subtitle labelPeriode has-text-dark">Période</label>
      <div class="periode">
        <input class="input" @input="panneau.extensionOpportunite.periodeModifieManuellement=true"
               v-model="panneau.extensionOpportunite.periode"
               :disabled="disabled">
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/panier-mutation-type';
import inputCurrency from '@/components/general/inputCurrency';
import { getTarification } from '@/services/devis/ajoutProduit/ajoutProduitNumerique';
import * as planningNumeriqueConf from '@/components/creationOpportunite/configuration/planningNumeriqueConf';
import { datesStringToPeriodes } from '@/services/devis/ajoutProduit/ajoutProduit';
import infoWindowProduit from './infoWindowProduit';

const Panier = createNamespacedHelpers('panier');

export default {
  name: 'panneau-numerique',
  props: ['panneau', 'disabled'],
  data() {
    return {
      tarifications: planningNumeriqueConf.TYPE_TARIFICATION,
      isComponentDetailFacesLc: false,

    };
  },
  components: {
    inputCurrency,
    infoWindowProduit,
  },
  watch: {
    'panneau.extensionOpportunite.typeTarification': {
      handler() {
        this.actionChangeTypeTarification();
      },
    },
  },
  methods: {
    ...Panier.mapMutations({
      setRemoveProduit: types.REMOVE_PRODUIT_TYPE_PANNEAU_NUMERIQUE,
    }),
    suppressionPanneau() {
      this.setRemoveProduit(this.panneau);
    },
    async actionChangeTypeTarification() {
      const periodes = datesStringToPeriodes(this.panneau.extensionOpportunite.periode);
      const maPeriode = periodes[0];
      const tarif = await getTarification(this.panneau, maPeriode.debut);
      if (tarif !== null) {
        this.panneau.extensionOpportunite.tarifHt = parseFloat(tarif.prixUnitaire);
        this.panneau.extensionOpportunite.taxeMunicipale = parseFloat(tarif.liaisonsTarif.find(el => el.libelle.includes('Tlpe')).prixUnitaire);
        this.panneau.extensionOpportunite.fraisAdserving = parseFloat(tarif.liaisonsTarif.find(el => el.libelle.includes('Frais')).prixUnitaire);
      }
    },
  },
};
</script>

<style scoped>
  .inputFacesLc {
    padding-bottom:10px
  }
  .periode {
    padding: 5px 20px 5px 20px;
    background-color: #F2F7F9;
  }

  .labelPeriode {
    padding-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/composantsProduits/panneauNumerique.vue